import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getCalculationTemplates } from 'modules/accommodations/features/reservations/api';

export const useCalculationTemplatesQuery = (reservationId: string, partnerType: string) =>
  useQuery([QUERY_KEYS.RENTALS_CALCULATION_MAIL_TASKS, reservationId, partnerType], () =>
    getCalculationTemplates(reservationId, partnerType),
  );
